import React from 'react';
import './PDPContactLensFeatures.scss';

import { useSelector } from 'react-redux';
import { v4 } from 'uuid';

const PDPContactLensFeatures = props => {
  const { productData } = props;

  const dataLocale = useSelector(state => state.locale);

  const { FEATURE } = dataLocale;

  return (
    <div className="pdp-icontact-lens-features">
      <div className="main-content-wrapper">
        <div className="pdp-icontact-lens-features__title od-font-bold">
          {productData?.fullName}
        </div>
        <div className="pdp-icontact-lens-features__list">
          {productData?.pdpEnrich?.map(({ url }) => (
            <img key={v4()} alt={FEATURE} src={url} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PDPContactLensFeatures;
